import "./footer.css"
import logo from "../../assets/logo.svg"
import React from "react";

function Footer() {
    return (
        <div className="footer">
            <div className="footer_content">
                <div>
                    <a href="https://www.choicetrade.com/"><img src={logo} alt=""/></a>
                    <p className="footer_text">Copyright 2000-{new Date().getFullYear()} ChoiceTrade. All rights reserved Member FINRA and <a
                        style={{textDecoration: "none"}} href="https://www.sipc.org/">SIPC</a></p>
                </div>

            </div>
        </div>
    )
}

export default Footer